export default {

    /**
     * Get tasks list
     * @param state
     * @returns {default.campaigns|{}}
     */
    getList: state => ({task_id}) => {

        // Return tasks list
        return Object.values(state.notifications).filter((ut) => (ut.task_id === task_id));
    },

    /**
     * Get task notifications
     * @param state
     */
    getNotifications: state => ({task_id, type, zone, external_id}) => {

        // Create array if not
        if (!Array.isArray(type)) type = [type];

        // Check for values
        if (state.aggregate[task_id] === undefined || state.aggregate[task_id][zone] === undefined) return 0;

        // not counter
        let cntr = 0, info = false;

        // All types
        for (const t of type) {
            if (state.aggregate[task_id][zone][t] !== undefined) {

                // Calc summ
                Object.entries(state.aggregate[task_id][zone][t]).forEach(([k, i]) => {

                    // Check for externals
                    if (external_id === undefined || k == external_id) {
                        cntr += i.count;
                        info = i.info;
                    }

                });
            }
        }

        // Return tasks list
        return {count: cntr, info};
    },

    /**
     * Get task notifications
     * @param state
     */
    // eslint-disable-next-line no-unused-vars
    getNotificationsCount: state => ({task_id, type, zone, external_id}) => {

        // Get nots
        let {count} = window.app.$get('notifications/getNotifications', {task_id, type, zone, external_id});

        // Return tasks list
        return count ? count : 0;
    },

    /**
     * Get users comments count
     * @param state
     */
    getUsersComments: state => {

        // Skan all notifications
        return Object.values(state.notifications).filter(i =>
            (i.action_type === 'comment' || i.action_type === 'mention-comment')
        );
    },

    /**
     * Get users comments count
     * @param state
     */
    getAllNotificationsCount: state => (type) => {

        // Create array if not
        if (!Array.isArray(type)) type = [type];

        // Skan all notifications
        return Object.values(state.notifications).filter(i =>
            (type.includes(i.action_type))
        ).length;

    },

    /**
     * Get first notification
     * @param state
     * @returns {default.campaigns|{}}
     */
    getFirstNotification: state => ({task_id, type}) => {

        // Not found by default
        let fldID = false;

        // Skan all notifications
        Object.values(state.notifications).filter(i => i.action_type === type).forEach(n => {

            // Unpack parents
            if (n.parents && n.parents.split(",").includes((task_id).toString())) {
                // Store found value;
                fldID = n.source_id;
                return;
            }
        });

        // Nothing found
        return fldID;
    },

    /**
     * Check does task has notifications
     * @param state
     */
    hasNotifications: state => (task_id) => {

        // Check for values
        return state.aggregate[task_id] !== undefined;
    },

    /**
     * Get notification by id
     * @param state
     * @returns {default.campaigns|{}}
     */
    getByID: state => (id) => {
        // Return notification list
        return state.notifications[id];
    },

    /**
     * Notificatinos list
     * @param state
     */
    getTreeNotificationsList: state => {
        return state.treeNotificationsList;
    },

    /**
     * Notificatinos list
     * @param state
     */
    getTreeFilterNotificationsList: state => {
        let resNots = [];
        for (const itm of state.treeNotificationsList) {
            if (!['assignee', 'my-task-4-today', 'has-deadline'].includes(itm.type)) resNots.push(itm);
        }

        // Return nots
        return resNots;
    },

    /**
     * All notificatinos list
     * @param state
     */
    getAll: state => {
        return state.notifications;
    },

    getNotificationSettings: state => {
        return state.notificationSettings
    }
}
